import { GenericMqttMessageContent } from '../generic-mqtt-message-content.model';

export class PingResponse {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            this.apiVersion = json['api-version'];
            this.correlationData = new CorrelationData(json['correlation-data']);
            this.content = new GenericMqttMessageContent(json['content']);

            delete this['api-version'];
            delete this['correlation-data'];
        }
    }

    // api-version: string;
    apiVersion: string;
    subject: string;
    correlationData: CorrelationData;
    content: GenericMqttMessageContent;
}

export class CorrelationData {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    installationId: string;
    siteId: number;
}
